// extracted by mini-css-extract-plugin
export default {"caption":"InnerMessageFooter_caption__YnYCK"};